export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-unlock-5fc2e060f030a75e0ba7c8144c6300e4.svg";